import { Search } from "@mui/icons-material";
import PersianSupportTextField from "Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField";
import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";
import i18next from "i18next";
import { useAtom } from "jotai";
import React, { useEffect, useState } from "react";
import { searchAtom } from "../../shared/Atom.search";

const SearchLanguage = () => {
  const searchMessage = FindLangKey("general-public-search");
  const [, setSearch] = useAtom(searchAtom);
  const [text, setText] = useState("");
  useEffect(() => {
    const timeOut = setTimeout(() => {
      setSearch(text);
    }, 2000);
    return () => clearTimeout(timeOut);
  }, [text]);
  return (
    <React.Fragment>
      <PersianSupportTextField
        isEnglish={i18next.language === "en"}
        label={searchMessage}
        onlyIcon={<Search />}
        isSmall={true}
        onChange={setText}
      />
    </React.Fragment>
  );
};

export default SearchLanguage;
